import { css } from '@microsoft/fast-element';

export const ReducedFileUploadStyles = css`
  .upload-new-file {
    height: 48px;
    margin-top: 16px;
    border-top: 1px dashed rgb(255 255 255 / 19%);
    border-bottom: 1px dashed rgb(255 255 255 / 19%);
    display: flex;
    align-items: center;
  }

  .upload-button {
    height: 32px;
    margin-left: auto;
  }
`;
